import { PubModelVersion } from '@/types/pub-models'
import useCreateDetail, {
  UseCreateDetailOptions,
} from '../core-hooks/useCreateDetail'
import useDeleteDetail, {
  UseDeleteDetailOptions,
} from '../core-hooks/useDeleteDetail'
import useGetDetail, { UseGetDetailOptions } from '../core-hooks/useGetDetail'
import useGetList, { UseGetListOptions } from '../core-hooks/useGetList'
import useUpdateDetail, {
  UseUpdateDetailOptions,
} from '../core-hooks/useUpdateDetail'
import buildService from '../create-service'
import queryKeys from '../query-keys'

const service = buildService<PubModelVersion>({
  pathCategory: 'pub_model_versions',
})

export function useGetPubModelVersion({
  id,
  ...options
}: UseGetDetailOptions<PubModelVersion>) {
  const query = useGetDetail<PubModelVersion>({
    id,
    queryKey: queryKeys.pubModelVersions.detail({
      id,
      filters: options.filters,
    }),
    serviceFn: service.getDetail,
    ...options,
  })

  return {
    pubModelVersion: query.data,
    ...query,
  }
}

export function useGetPubModelVersions({
  filters,
  ...options
}: UseGetListOptions<PubModelVersion> = {}) {
  const query = useGetList<PubModelVersion>({
    filters,
    queryKey: queryKeys.pubModelVersions.list({ filters }),
    serviceFn: service.getList,
    ...options,
  })

  return {
    pubModelVersions: query.allData,
    ...query,
  }
}

export function useCreatePubModelVersion(
  options: UseCreateDetailOptions<PubModelVersion> = {},
) {
  const mutation = useCreateDetail<PubModelVersion>({
    serviceFn: service.createDetail,
    ...options,
  })

  return {
    createPubModelVersion: mutation.mutate,
    createPubModelVersionAsync: mutation.mutateAsync,
    ...mutation,
  }
}

export function useUpdatePubModelVersion(
  options: UseUpdateDetailOptions<PubModelVersion> = {},
) {
  const mutation = useUpdateDetail<PubModelVersion>({
    serviceFn: service.updateDetail,
    ...options,
  })

  return {
    updatePubModelVersion: mutation.mutate,
    updatePubModelVersionAsync: mutation.mutateAsync,
    ...mutation,
  }
}

export function useDeletePubModelVersion(options: UseDeleteDetailOptions = {}) {
  const mutation = useDeleteDetail<PubModelVersion>({
    serviceFn: service.deleteDetail,
    ...options,
  })

  return {
    deletePubModelVersion: mutation.mutate,
    deletePubModelVersionAsync: mutation.mutateAsync,
    ...mutation,
  }
}
